<template>

  <div v-if="(getUserView()=='operator')">
      <DataOperator />
  </div>
  <div v-else>
      <DataDefault />
  </div>
 
</template>

<script>
import DataDefault from "./container-list-v-default.vue";
import DataOperator from "./container-list-v-operator.vue";

export default {
  created() {
    this.getUserView();
  },
  components: {
    // eslint-disable-next-line
    DataDefault, 
    // eslint-disable-next-line
    DataOperator,
  },
  methods:{
    getUserView()
    {
      return this.$store.getters["auth/getUserView"];
    }
  }
};
</script>

<style scoped>
  .ph { /* page header */
    height: 50px;
  } 
  
</style>
